import DateFormat from "examples/ReuseFunctions/DateFormat";

const AssigneeHistory = (previousdata: string | null, employeeName: string) => {
  const currentTime = DateFormat();
  const newEntry = { "Assigned to": employeeName, Date: currentTime };

  // Flatten the previous data
  const flattenData = <T,>(data: (T | T[])[]): T[] => {
    return data.reduce<T[]>((acc, item) => {
      if (Array.isArray(item)) {
        return acc.concat(flattenData(item));
      } else {
        acc.push(item);
        return acc;
      }
    }, []);
  };

  const historyDataArray = previousdata
    ? flattenData(JSON.parse(previousdata))
    : [];
  historyDataArray.push(newEntry);

  return JSON.stringify(historyDataArray);
};

export default AssigneeHistory;
